import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {IPost} from '../../../../models/Post'
import NoImage from '../../../assets/imgs/no-image.png'
import {PHOTO_RATIO} from '../../../config/constants'
import {getPostUrl} from '../../../helpers/post'
import ResponsiveImg, { getResponsiveSrcSetsFromWH } from '../../common/ResponsiveImg'
import styles from './PostItem.scss'
import { getGlobalEnv } from '../../../helpers/coreUtil'

const thumbnailWidth = 320 //px
const PostItem = ({post}: {
  post: IPost
}) => {
  const {
    photo: url = NoImage,
    title,
    author: { name }
  } = post
  const postUrl = getPostUrl(post, false, false)
  const cdn = getGlobalEnv('CDN_BASE_URL')
  const srcSet = getResponsiveSrcSetsFromWH(url, 200, undefined, { webp: true, cdn })

  return <div className={[styles.container, 'flex-grow-0 flex-shrink-0 d-flex flex-column position-relative']
    .filter(Boolean).join(' ')}>
    <div className={['overflow-hidden', styles.image].filter(Boolean).join(' ')}>
      <Link to={postUrl}
            className={[styles.imgWrapper, 'd-flex align-items-center justify-content-center'].join(' ')}>
        <ResponsiveImg
          caption="Post photo"
          url={url}
          noLazy={false}
          srcSet={srcSet}
          width={thumbnailWidth}
          height={thumbnailWidth / PHOTO_RATIO}
          className={styles.photo}
        />
      </Link>
    </div>
    <div className={['text-left d-flex flex-column', styles.info].join(' ')}>
      <Link to={postUrl}
            className={
              ['d-block font-weight-bold text-dark text-carstay-black', styles.title]
                .filter(Boolean).join(' ')
            }>
        <span className={styles.lineClamp}>{title}</span>
      </Link>
      <div className="d-flex justify-content-between align-items-center mt-auto">
        <div className={['small ellipsis font-weight-bold', styles.name].join(' ')}>
          <span>{name || <FormattedMessage id="post.addressNotFound"/>}</span>
        </div>
      </div>
    </div>
  </div>
}
PostItem.displayName = 'PostItem'
export default PostItem
